// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectMulti from "components/layout/DropdownSelectors/SelectorSelectMulti";

// ** Search Hooks
import useFilterActivityType from "hooks/filters/useFilterActivityType";

// #####################################################

const useActivityTypeSelector = ({ type, setType }) => {
	const { t } = useTranslation(["common"]);

	const filterActivityType = useFilterActivityType({
		initial: type,
		allCheckedInitial: false,
	});

	const { items, selected, setSelected, compute } = filterActivityType;

	const renderActivityTypeSelector = () => (
		<SelectorSelectMulti
			label={t("common:type")}
			emptyText={t("common:none.3")}
			items={items}
			selected={selected}
			onAccept={(value) => {
				setSelected(value);
				setType(compute.valueToApi(value));
			}}
			withMobileVersion
			withAdditionalInfo
		/>
	);

	// #####################################################

	return {
		filterActivityType,
		renderActivityTypeSelector,
	};
};

export default useActivityTypeSelector;

// #####################################################
